export function setAuthToken(authToken) {
    window.localStorage.setItem('token', authToken);
}
export function setUserName(user_name) {
    window.localStorage.setItem('user_name', user_name);
}



export function setUser(user){
    window.localStorage.setItem('user', user)
}
export function getAuthToken() {
    return window.localStorage.getItem('token');
}

export function clearAuthToken() {
    window.localStorage.removeItem('token');
}

export function setPermissions(permissionsJSON) {
    const permissions = JSON.stringify(permissionsJSON);
    window.localStorage.setItem('permissions', permissions);
}

export function hasPermission(permissionName) {
    const permissions = JSON.parse(window.localStorage.getItem('permissions'));

    for (let i = 0; i < permissions.length; i++) {
        if (permissions[i].name === permissionName) {
            return true;
        }
    }

    return false;
}

export function clearlocalStorage() {
    window.localStorage.clear()
}

export function applyArgsToPath(path, args) {
    for (let [key, value] of Object.entries(args)) {
        path = path.replace('${' + key + '}', value)
    }
    return path;
}